var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",class:{
        'pb-15': _vm.fullscreen
    },staticStyle:{"top":"0","left":"0","right":"0"},style:({ 
        height: (_vm.fullscreen ? '100%' : '33%'),
        minHeight: (_vm.fullscreen ? 'auto' : '250px'),
        position: (_vm.fullscreen ? 'absolute' : 'static') 
    })},[_c('div',{staticStyle:{"max-width":"100%"},attrs:{"id":"player"}})])}
var staticRenderFns = []

export { render, staticRenderFns }